import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Auth, recordActions } from '../../config/configuration/react';
import {
  calculateEntryStockResult,
  calculatePricingResult,
  calculateMinimValuePricing,
  calculateMyValuationEt,
} from '../../Store/helpers/pricing';
import { listVat } from '../../config';

let pricingUserResultChange = '';
export const useCalculate = () => {
  const { recordId } = useParams();
  const dispatch = useDispatch();
  const country = Auth.country();
  const showET = country === 'ES';
  const listPlanedDelay = [0, 15, 30, 45, 60, 90, 120];
  const userPricing = useSelector((state) => state.reduxRecords.data[recordId]?.userPricing || {});
  const entryStockKey = userPricing?.entryStockKey;
  const tradeInUser = useSelector((state) => state.reduxRecords.data[recordId]?.quotation?.tradeInUser) || 0;
  const tradeInAutobiz = useSelector((state) => state.reduxRecords.data[recordId]?.quotation?.tradeInAutobiz) || 0;
  const refurbishmentCostCarcheck = _.round(
    useSelector((state) => state.reduxRecords.data[recordId]?.expertiseCosts?.mdCosts),
  );
  const rotation = useSelector((state) => state.reduxRecords.data[recordId]?.quotation?._salesSpeed?.rotation);
  const customerVat = useSelector((state) => state.reduxRecords.data[recordId]?.customer?.vat);
  const supervisorVat = useSelector((state) => state.reduxRecords.data[recordId]?.supervisor?.vat);
  const versions = useSelector((state) => state.reduxRecords.data[recordId]?.vehicle?.versionsData);
  const bodyCosts = useSelector((state) => state.reduxRecords.data[recordId]?.expertiseCosts?.bodyCosts);
  const marketValue = useSelector((state) => state.reduxRecords.data[recordId]?.quotation?.marketValue);
  const sourceId = useSelector((state) => state.reduxRecords.data[recordId]?.record?.sourceId);
  const pricingAutobizResult = useSelector(
    (state) => state.reduxRecords.data[recordId]?.quotation?.pricingAutobizResult,
  );
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [secondtooltipOpen, setSecondTooltipOpen] = useState(false);
  const monkReportStatus = useSelector((state) => state.reduxRecords.data[recordId]?.monkReportStatus || []);
  const autobizRotation = rotation === 0 ? 60 : rotation;
  const getPricing = (rId, plannedDelay, userValue, refurbishmentCostUser) => {
    dispatch(recordActions.fetchPricing(rId, plannedDelay, userValue, refurbishmentCostUser));
  };
  const aiReport = useSelector((state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.aiReport);
  let pricingUserResult = useMemo(
    () => calculatePricingResult(tradeInUser, userPricing.refurbishingCosts),
    [tradeInUser, userPricing.refurbishingCosts],
  );
  const vat = (supervisorVat && supervisorVat) || customerVat;

  const updateUserPricing = async (data) => {
    await dispatch(recordActions.updateUserPricing(data));
  };

  useEffect(() => {
    pricingUserResultChange = calculateEntryStockResult(
      calculatePricingResult(tradeInUser, userPricing.refurbishingCosts),
      entryStockKey,
    );
    updateUserPricing({ pricingUserResult: pricingUserResultChange });
  }, [tradeInUser, userPricing.refurbishingCosts]);
  useEffect(() => {
    updateUserPricing({ marketValue });
  }, [marketValue]);
  pricingUserResult = (pricingUserResultChange && pricingUserResultChange) || pricingUserResult;
  const prixEt = useMemo(
    () => calculateMyValuationEt(pricingAutobizResult, userPricing && userPricing.vatSpain),
    [pricingAutobizResult, userPricing],
  );
  const prixEtUser = useMemo(
    () =>
      calculateMyValuationEt(
        calculateMinimValuePricing(sourceId, pricingUserResult),
        userPricing && userPricing.vatSpain,
      ),
    [pricingUserResult, userPricing],
  );

  useEffect(() => {
    updateUserPricing({ prixEtUser });
  }, [prixEtUser]);

  useEffect(() => {
    if (!userPricing.vatSpain) {
      switch (vat) {
        case 'yes_100percent':
        case 'yes_50percent':
          updateUserPricing({ vatSpain: vat });
          break;
        default:
          updateUserPricing({ vatSpain: 'REBU' });
          break;
      }
    }
  }, []);

  useEffect(() => {
    if (!versions) return;
    getPricing(
      recordId,
      userPricing.plannedDelay,
      userPricing.marketValue,
      parseInt(userPricing.refurbishingCosts, 10),
    );
  }, [userPricing, versions]);

  return {
    userPricing,
    setValue: (v) => updateUserPricing(v),
    listPlanedDelay,
    rotation,
    marketValue,
    refurbishmentCostCarcheck,
    pricingAutobizResult,
    pricingUserResult: calculateMinimValuePricing(sourceId, pricingUserResult),
    listVat,
    prixEt,
    prixEtUser,
    showET,
    bodyCosts: _.round(bodyCosts),
    tradeInAutobiz,
    tradeInUser,
    tooltipOpen,
    setTooltipOpen,
    autobizRotation,
    secondtooltipOpen,
    setSecondTooltipOpen,
    aiReport,
    monkReportStatus,
  };
};
